// extracted by mini-css-extract-plugin
export var alignCenter = "_8s-d";
export var bannerShown = "_8s-6";
export var buttonContent = "_8s-0";
export var cardList = "_8s-1";
export var centerContent = "_8s-2";
export var chevron = "_8s-3";
export var closePanelButton = "_8s-k";
export var conversationContextContainer = "_8s-l";
export var conversationDetailContainer = "_8s-4";
export var detailWrapper = "_8s-7";
export var dropdownButton = "_8s-e";
export var dropdownTitle = "_8s-9";
export var fullHeight = "_8s-5";
export var hidden = "_8s-a";
export var icon = "_8s-b";
export var mergeSuggestionWrapper = "_8s-m";
export var panel = "_8s-i";
export var portalButtonsWrapper = "_8s-c";
export var right = "_8s-j";
export var tableSummaryContainer = "_8s-8";
export var tableSummaryHeader = "_8s-g";
export var threeDotsButton = "_8s-f";
export var wide = "_8s-h";